import type { PnidEntry } from './pnidSchemas'

export function missingGraphReferences(entries: PnidEntry[]): string[] {
  const ids = new Set(entries.map((entry) => entry.id))
  const needed = new Set<string>()
  for (const entry of entries) {
    if (entry.type === 'pnid-edge') {
      needed.add(entry.data.source_node_id)
      if (entry.data.type === 'dexpi') needed.add(entry.data.target_node_id)
    } else if (entry.type === 'pnid-node-overlay')
      needed.add(entry.data.node_id)
  }
  return [...needed].filter((id) => !ids.has(id)).sort()
}
